var ___EXPOSE_LOADER_IMPORT___ = require("-!builtin:swc-loader??ruleSet[1].rules[4].use[0]!./zulip_test.ts");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../node_modules/.pnpm/expose-loader@5.0.1_webpack@5.99.7/node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["zulip_test"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["zulip_test"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
